<template>
  <div class="component_card">
    <div class="column columns redeem_form mw100">
      <div class="column">
        <div class="column tal_c">
          <div class="column upper fat">{{$t("msg.confirm_redeem")}}</div>
          <div class="column">
            <p class="fat amount_btc">{{redeemData.estimatedAmount.toFixed(2)}} USDT</p>
          </div>
          <div class="column email-info">
            <p v-html="$t('msg.info_redeem_email_step_4')"></p>
          </div>
          <div class="column" v-if="rush">
            <p v-html="$t('msg.info_redeem_step_4')"></p>
          </div>
          <div class="column" v-else>
            <p v-html="$t('msg.info_redeem_step_5')"></p>
          </div>
          <div class="column upper">
            <router-link to="/transactions/redemption">{{$t("msg.view_status")}}</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  props: ["redeemData", "rush"],
  created() {},
  mounted() {},
  data: () => ({}),
  components: {},
  methods: {},
  computed: {
    ...mapGetters([])
  },
  watch: {}
};
</script>




// WEBPACK FOOTER //
// src/components/private/services/redeem_steps/RedeemStep4.vue